export function getFileNameFromPath(path: string): string{
    const routes: string[] = path.split('/');
    return routes[routes.length - 1];
}
